// Function index:
//   HomeChoice               — { kind: 'play' | 'build' | 'admin', ... }.
//   showTitleScreen(user)    — the living-hex title screen. If `user` is null
//       it runs login/signup first (title/auth.ts), then the main menu
//       (title/menu.ts) and resolves with { user, choice }. The hex-field
//       backdrop and the world ticker run for the lifetime of the screen and
//       are stopped on resolve.
//
// Façade: auth flow lives in title/auth.ts, menu + drawer in title/menu.ts,
// drawer form builders in title/forms.ts, hex-field backdrop in title/hexfield.ts,
// world ticker in title/ticker.ts.

import type { AuthUser } from '../api.js';
import { runAuth } from './title/auth.js';
import { startHexField } from './title/hexfield.js';
import { runMenu } from './title/menu.js';
import { startTitleTicker } from './title/ticker.js';

export type HomeChoice =
  | { kind: 'play';  partyId: number }
  | { kind: 'build'; worldId: number }
  | { kind: 'admin' };

export async function showTitleScreen(initialUser: AuthUser | null): Promise<{ user: AuthUser; choice: HomeChoice }> {
  const screen = document.getElementById('screen-title')!;
  screen.hidden = false;
  const stopField = startHexField(document.getElementById('hexfield') as HTMLCanvasElement);
  const tickerEl = document.getElementById('title-ticker');
  const stopTicker = tickerEl ? startTitleTicker(tickerEl) : (): void => {};

  const user = initialUser ?? await runAuth();
  const choice = await runMenu(user);

  stopTicker();
  stopField();
  screen.hidden = true;
  return { user, choice };
}
